import { render } from "./PaginationComponent.vue?vue&type=template&id=879c2e86"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__